
<div :data-component-name="$options.name" class="div_container">
  <b-row class="m-0">
    <div
      v-if="content.titre"
      class="titre graphik_bold"
      :class="[content.image ? 'titre-image' : 'titre-no-image']"
      :style="{ 'background-color': content.couleurFondTitre }"
    >
      <b-card-img-lazy
        v-if="content.image"
        :src="jel_getFichierSrc(content.image)"
        :alt="content.titre"
        class="image ml-1"
      >
      </b-card-img-lazy>
      <span :class="[content.image ? 'ml-1' : 'ml-5']" v-html="content.titre"> </span>
    </div>

    <div class="text-container"><span class="texte" v-html="content.texte"></span></div>
  </b-row>
</div>
